// extracted by mini-css-extract-plugin
export default {"input":"custominput_input__AQGtC","invalid_Border":"custominput_invalid_Border__LhRR3"};